/**
 * HAPTIC_FEEDBACK — feedback háptico discreto, como progressive enhancement.
 *
 * Único punto de contacto con `navigator.vibrate`: nada en la app llama a la
 * API del navegador directo. Si el dispositivo no soporta vibración (la
 * mayoría de desktop, Safari en iOS), cada función es un no-op silencioso —
 * la app tiene que quedar exactamente igual de funcional sin esto.
 *
 * El feedback visual (estados, badges, animaciones, mensajes de éxito/error)
 * es siempre la fuente de verdad; esto es un acento encima, nunca el único
 * canal de una confirmación.
 */

const supported = typeof navigator !== 'undefined' && 'vibrate' in navigator;

// Preparado para un ajuste de usuario a futuro ("desactivar vibración") sin
// tener que tocar los call sites — hoy nadie lo apaga, pero el interruptor
// ya existe.
let enabled = true;

function vibrate(pattern: number | number[]): void {
  if (!supported || !enabled) return;
  try {
    navigator.vibrate(pattern);
  } catch {
    // Decorativo: un navegador que lo rechace (política de permisos, tab en
    // background) no debe convertirse en un error visible para nadie.
  }
}

export const haptic = {
  /** Toques menores: cambiar un tab, un segmented control, un toggle. */
  light: () => vibrate(8),
  /** Una acción se completó: guardar, confirmar, un drop válido. */
  success: () => vibrate(18),
  /** Algo necesita atención — nunca reemplaza el mensaje o badge de error. */
  warning: () => vibrate([12, 40, 12]),
  /** Soporte real del dispositivo, por si un componente necesita saberlo. */
  isSupported: () => supported,
  /** Para un futuro ajuste de usuario. */
  setEnabled: (value: boolean) => { enabled = value; },
};
